import React from 'react';
import classes from './CoverPage.css';
import Config from 'Config';

const coverPage = () => {

    let imageUrl = Config.princeStyles + "/Report_COVER_01.png";
    let logoUrl = Config.princeStyles + "/iS_logo_big.png";

    let bgStyle = {
        backgroundImage: "url('" + imageUrl + "')"
    };

    return (
        <div style={bgStyle} className="CoverPage">
            <div className="infoBox">
                <div className="logo">
                    <img src={logoUrl} alt="inStream Solutions" />
                </div>
                <h2>Portfolio Simulator with a Fee-based Fixed Indexed Annuity</h2>
            </div>
        </div>
    );
};

export default coverPage;


// WEBPACK FOOTER //
// ./src/components/CoverPage/CoverPage.js